// ============================================================================
// FRONT OFFICE ENDPOINTS (E2 Front Office Workspace)
// Backend: FrontOfficeController — [Route("api/v1/front-office")]
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/front-office';

export const frontOfficeEndpoints = {
  /** GET /api/v1/front-office/dashboard?propertyId=…&date=… */
  dashboard: () => buildEndpoint(`${BASE_PATH}/dashboard`),
  /** GET /api/v1/front-office/arrivals?propertyId=…&date=…&page=…&pageSize=… */
  arrivals: () => buildEndpoint(`${BASE_PATH}/arrivals`),
  /** GET /api/v1/front-office/departures?propertyId=…&date=…&page=…&pageSize=… */
  departures: () => buildEndpoint(`${BASE_PATH}/departures`),
  /** GET /api/v1/front-office/in-house?propertyId=…&page=…&pageSize=… */
  inHouse: () => buildEndpoint(`${BASE_PATH}/in-house`),
  /** GET /api/v1/front-office/day-sheet/search?propertyId=…&q=… */
  daySheetSearch: () => buildEndpoint(`${BASE_PATH}/day-sheet/search`),
  /** GET /api/v1/front-office/day-sheet/summary?propertyId=…&date=… */
  daySheetSummary: () => buildEndpoint(`${BASE_PATH}/day-sheet/summary`),
  /** GET /api/v1/front-office/room-board?propertyId=…&date=… */
  roomBoard: () => buildEndpoint(`${BASE_PATH}/room-board`),
  /** PATCH /api/v1/front-office/rooms/{roomId}/status */
  roomStatus: (roomId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/rooms/:roomId/status`, { roomId }),
  /** POST /api/v1/front-office/room-move */
  roomMove: () => buildEndpoint(`${BASE_PATH}/room-move`),
} as const;

export default frontOfficeEndpoints;
